import { render, staticRenderFns } from "./OrgAdminManageStaff.vue?vue&type=template&id=45b7efed&scoped=true&"
import script from "./OrgAdminManageStaff.vue?vue&type=script&lang=ts&"
export * from "./OrgAdminManageStaff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b7efed",
  null
  
)

export default component.exports